// Real Time Energy Data bar chart

import React from "react";
import ReactECharts from "echarts-for-react";

const RealTimeEnergyDataBarChart: React.FC = () => {
  const buyData = [10, 15, 62, 20, 25, 5, 30];
  const sellData = [5, 10, 15, 8, 12, 3, 35];
  const daysOfWeek = ["Fri", "Sat", "Sun", "Mon", "Tue", "Wed", "Thu"];

  const options = {
    xAxis: {
      type: "category",
      data: daysOfWeek,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      name: "kWh",
      nameLocation: "end",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      axisPointer: {
        type: "shadow",
      },
      formatter: (params: any) => {
        const [buy, sell] = params;
        return `
             <div style="padding: 8px; font-size: 12px; color: #fff; border-radius: 4px;">
               <div>${buy.axisValue}</div>
               <div style="display: flex; align-items: center;">
                 <span style="width: 8px; height: 8px; background-color: ${buy.color}; margin-right: 4px; border-radius: 50%;"></span>
                 Buy: ${buy.data}
               </div>
               <div style="display: flex; align-items: center;">
                 <span style="width: 8px; height: 8px; background-color: ${sell.color}; margin-right: 4px; border-radius: 50%;"></span>
                 Sell: ${sell.data}
               </div>
             </div>
           `;
      },
    },
    legend: {
      data: ["Buy", "Sell"],
      textStyle: {
        fontSize: 10,
        color: "#5F6368",
      },
    },
    grid: {
      left: "3%",
      right: "3%",
      bottom: "5%",
      containLabel: true,
    },
    series: [
      {
        name: "Buy",
        data: buyData,
        type: "bar",
        itemStyle: {
          color: "#1976d2",
        },
        barWidth: "40%",
      },
      {
        name: "Sell",
        data: sellData,
        type: "bar",
        itemStyle: {
          color: "#9CE976",
        },
        barWidth: "40%",
      },
    ],
  };

  return (
    <ReactECharts option={options} style={{ height: "330px", width: "100%" }} />
  );
};

export default RealTimeEnergyDataBarChart;
